import * as React from "react"

function SvgChevronRight(props) {
  return (
    <svg
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.383 12a.38.38 0 01-.148-.03A.398.398 0 016 11.6c0-.108.036-.202.11-.28l4.994-5.361L6.186.692a.406.406 0 01-.11-.287c0-.114.037-.21.11-.288A.352.352 0 016.454 0c.105 0 .194.04.267.117l5.17 5.56a.4.4 0 01.109.282c0 .11-.036.203-.11.281l-5.245 5.643a.357.357 0 01-.126.088.358.358 0 01-.136.029z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgChevronRight
